module.exports = __webpack_public_path__ + "assets/Omicron.210da46e64a3ed24edf79e05730d11de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Omicron.png
// module id = 793
// module chunks = 0